import { render } from "./footerCTA.vue?vue&type=template&id=2be524eb"
import script from "./footerCTA.vue?vue&type=script&lang=js"
export * from "./footerCTA.vue?vue&type=script&lang=js"

import "./footerCTA.vue?vue&type=style&index=0&id=2be524eb&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__